import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import PageHeader from '@/components/Layout/PageHeader.vue';
import AppointmentItem from './AppointmentItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentsIndex',
  setup(__props) {

const items = [
    {
        id: 1,
        time: '2023-02-23 10:00:00',
        name: 'Initial Consultation',
        status: 'confirmed',
        payment_status: 'paid'
    },
    {
        id: 2,
        time: '2023-03-02 10:00:00',
        name: 'Follow-Up Consultation',
        status: 'confirmed',
        payment_status: 'overdue'
    },
    {
        id: 3,
        time: '2023-03-09 10:00:00',
        name: 'Follow-Up Consultation',
        status: 'confirmed',
        payment_status: 'unpaid'
    }
]

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
          return _createElementVNode("div", {
            key: item.id
          }, [
            _createVNode(AppointmentItem, {
              item: item,
              class: "my-2"
            }, null, 8, ["item"]),
            _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
          ])
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})